import React from 'react';
import InputField from 'components/Input-Field/input-field';
import {
  Box,
  Button,
  Grid,
} from '@mui/material';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { DataGrid } from '@mui/x-data-grid';
import { formatCurrency } from 'utils/formatter';
import SelectInput from 'components/Select-Field/select-field';

const LOCALE = 'USD';

const Remittance = ({
  remittanceModel,
  remittanceData,
  isProcessPayment,
  fnOnSubmitPaymentHandler,
}) => {

  const TABLE_HEADER = [
    { field: 'id', headerName: 'Id', },        
    { field: 'payer', headerName: 'Payer', flex: 1 },
    { field: 'payee', headerName: 'Payee', flex: 1 },
    { field: 'paymentAmount', headerName: 'Amount', renderCell: (params) => formatCurrency(params.row.paymentAmount, LOCALE, 'standard')},
    { field: 'paymentNumber', headerName: 'Payment Number', flex: 1 },
    { field: 'paymentDate', headerName: 'Payment Date', flex: 1 },
    { field: 'paymentMode', headerName: 'Mode', flex: 1 },
    { field: 'memo', headerName: 'Memo', flex: 1 },
  ];

  const formik = useFormik({
    initialValues: { ...remittanceModel },

    validationSchema: Yup.object().shape({
      paymentAmount: Yup.number().positive().required('Payment Amount is required'),
      paymentMode: Yup.string().required('Payment Mode is required'),
      paymentNumber: Yup.string().required('Payment Number is required'),
      paymentDate: Yup.date().required('Payment Date is required'),
    }),

    onSubmit: values => { fnOnSubmitPaymentHandler(values); },
  });

  return (
    <Box>
      {isProcessPayment ?
        <Box
          m='10px 0 0 0'
        >
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
              <Grid size={{xs: 6, sm: 3}}>
                <InputField
                  label='Payment Amount'
                  name='paymentAmount'
                  type='number'
                  value={formik.values.paymentAmount}
                  variant='outlined'
                  fullWidth
                  margin='dense'
                  disabled
                  error={Boolean(formik.touched.paymentAmount && formik.errors.paymentAmount)}
                  helperText={formik.touched.paymentAmount && formik.errors.paymentAmount}                  
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid size={{xs: 6, sm: 3}}>
                <SelectInput
                  label='Payment Mode'
                  name='paymentMode'
                  value={formik.values.paymentMode}
                  fullWidth={true}
                  variant='outlined'
                  error={Boolean(formik.touched.paymentMode && formik.errors.paymentMode)}
                  helperText={Boolean(formik.touched.paymentMode && formik.errors.paymentMode)}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  options={['CHECK', 'ACH', 'ZELLE', 'INTRAC', 'CREDIT_CARD', 'DIRECT_DEPOSIT']}
                  margin='dense'
                  size='small'
                />
              </Grid>              
              <Grid size={{xs: 6, sm: 3}}>
                <InputField
                  label='Payment Number'
                  name='paymentNumber'
                  type='text'
                  value={formik.values.paymentNumber}
                  variant='outlined'
                  fullWidth
                  margin='dense'
                  error={Boolean(formik.touched.paymentNumber && formik.errors.paymentNumber)}
                  helperText={formik.touched.paymentNumber && formik.errors.paymentNumber}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid size={{xs: 6, sm: 3}}>
                <InputField
                  label='Payment Date'
                  name='paymentDate'
                  type='date'
                  value={formik.values.paymentDate}
                  variant='outlined'
                  fullWidth
                  margin='dense'
                  error={Boolean(formik.touched.paymentDate && formik.errors.paymentDate)}
                  helperText={formik.touched.paymentDate && formik.errors.paymentDate}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </Grid>
            </Grid>
            <Box
              display={'flex'}
              justifyContent={'flex-end'}
            >
              <Button
                type='submit'
                variant='contained'
                color='primary' style={{ marginTop: 5 }}>
                Process Payment
              </Button>              
            </Box>
          </form>
        </Box> : 
        null
      }
      <Box
        m='20px 0 0 0'
        height='40vh'
      >
        <DataGrid
          rows={remittanceData || []}
          columns={TABLE_HEADER}
          disableSelectionOnClick
        />
      </Box>
    </Box>
  );
};

export default Remittance;